/** @jsx jsx */
// ts-check
import { Flex } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
import ProductCardActions, { useContent } from './ProductCardActions';

export default function ProductCardActionsBar({
  product,
  children = undefined,
  ...rest
}) {
  const content = useContent(product);
  if (!content.hasContent) return null;
  return (
    <Flex
      gap={2}
      wrap="wrap"
      align="center"
      sx={{
        width: '100%',
        backgroundColor: 'light',
        padding: 2,
        paddingBottom: 0,
      }}
      {...rest}
    >
      <ProductCardActions product={product} />
    </Flex>
  );
}
